import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@pwc/pwc-deals-ui';
import { GROUP_DUPLICATE_ERROR } from 'common/helpers/duplicateTitleError';
import './GroupErrorMessage.scss';

type Props = {
  message: string;
};

const GroupErrorMessage: FC<Props> = ({ message }) => {
  const { t } = useTranslation();
  message = message || t(GROUP_DUPLICATE_ERROR);
  return (
    <div className="add-group-error">
      <Icon name="alert" className="icon-error fill" width="16" />
      <div className="message">{message}</div>
    </div>
  );
};

export default GroupErrorMessage;
